import React from 'react'
import './Loader.css'

const Loader = () => (
    <div className="Loader">
        <div className="Bounce1"></div>
        <div className="Bounce2"></div>
        <div className="Bounce3"></div>
    </div>
)

export default Loader
